v-container
  //- Title
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('cancellation.title') }}

  //- Policy Text
  v-row
    v-col(cols="12")
      for text, index in $tm('cancellation.policyText')
        p.text-body-1.mb-3(:key="index") {{ text }}

  v-divider.my-6

  //- Signature Section
  v-row
    v-col(cols="12")
      SignaturePad(
        v-model="form.signature"
        :label="$t('cancellation.signature')"
        :rules="[form.validCheck('signature')]"
      )
